import ArticleViewport from './components/ArticleViewport';
import DynastyCover from './components/DynastyCover';
import AsyncStory from './components/DynastyStory';
import AppCover from './components/AppCover';
import App404 from './components/App404';

const data = require('../../../../../data/basic.json');
module.exports = [
    {
        path: '',
        name: 'cover',
        component: AppCover,
        props: () => {
            return {
                data: data
            };
        }
    },
    {
        path: '/404',
        name: '404',
        component: App404,
        props: () => {
            return {
                data: data
            };
        }
    },
    {
        path: '/dynasty/:id',
        name: 'dynasty-vp',
        component: ArticleViewport,
        children: [
            {
                path: '',
                name: 'dynasty',
                component: DynastyCover,
                props: route => {
                    return {
                        id: route.params.id,
                        data: data.sections[route.params.id],
                        next: `/${route.name}/${route.params.id}/story`
                    };
                }
            },
            {
                path: 'story',
                name: 'story',
                component: AsyncStory,
                props: route => {
                    const sData = data.sections[route.params.id];
                    return {
                        id: route.params.id,
                        data: sData,
                        nextData: data.sections[sData.nextId],
                        next: '/dynasty/' + sData.nextId
                    };
                }
            }
        ]
    }
];
